// src/graphql/dashboard.graphql.ts
import { gql } from '@apollo/client';

export const GET_DASHBOARD_STATS = gql`
  query GetDashboardStats {
    getDashboardStats {
      todayPatients
      pendingTests
      todayRevenue
      reportsPending
    }
  }
`;